export default "__VITE_ASSET__Di5NRqc$__"